// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen.js';
import { changeLogQuery, dataRequestActionApprove, dataRequestActionReject, dataRequestHost, dataRequestList, hotelActionAddProblem, hotelActionStatuses, hotelGetStatus, hotelSettingGetChangeLog, hotelSettingGetSettings, hotelSettingQuery, hotelSettingQueryShopping, hotelSettingSave, jobActionAsAppendLearn, jobActionAsRestrictionShop, jobActionEnqueue, jobActionEnqueueEnqueuer, jobActionEnqueueHotel, jobActionRetry, jobActionTerminate, locationGetStatus, type Options, organizationActionBulkSave, organizationActionProvision, organizationActionSave, organizationGet, organizationGetChangeLog, organizationInsert, organizationLimitGetChangeLog, organizationLimitGetSettings, organizationLimitQuery, organizationLimitSave, organizationQuery, organizationSave, rateScrapeMetadataActionAddProblem, rateScrapeMetadataActionBulkSave, rateScrapeMetadataActionCachedShoppingMetrics, rateScrapeMetadataActionClear, rateScrapeMetadataActionPromote, rateScrapeMetadataActionPropagateShared, rateScrapeMetadataGet, rateScrapeMetadataGetChangeLog, rateScrapeMetadataQuery, rateScrapeMetadataSave, sessionDelete, sessionNewSession, sessionQuery, sharedRateScrapeMetadataActionPropagate, sharedRateScrapeMetadataActionStats, sharedRateScrapeMetadataGet, sharedRateScrapeMetadataGetChangeLog, sharedRateScrapeMetadataSave, systemValueActionGetCache, systemValueActionQueryAll, systemValueActionReload, systemValueSave, userGet, userGetChangeLog, userQuery } from '../sdk.gen.js';
import type { ChangeLogQueryData, ChangeLogQueryError, ChangeLogQueryResponse, DataRequestActionApproveData, DataRequestActionApproveError, DataRequestActionApproveResponse, DataRequestActionRejectData, DataRequestActionRejectError, DataRequestActionRejectResponse, DataRequestHostData, DataRequestHostError, DataRequestHostResponse, DataRequestListData, DataRequestListError, DataRequestListResponse, HotelActionAddProblemData, HotelActionAddProblemError, HotelActionAddProblemResponse, HotelActionStatusesData, HotelActionStatusesError, HotelActionStatusesResponse, HotelGetStatusData, HotelGetStatusError, HotelGetStatusResponse, HotelSettingGetChangeLogData, HotelSettingGetChangeLogError, HotelSettingGetChangeLogResponse, HotelSettingGetSettingsData, HotelSettingGetSettingsError, HotelSettingGetSettingsResponse, HotelSettingQueryData, HotelSettingQueryError, HotelSettingQueryResponse, HotelSettingQueryShoppingData, HotelSettingQueryShoppingError, HotelSettingQueryShoppingResponse, HotelSettingSaveData, HotelSettingSaveError, HotelSettingSaveResponse, JobActionAsAppendLearnData, JobActionAsAppendLearnError, JobActionAsAppendLearnResponse, JobActionAsRestrictionShopData, JobActionAsRestrictionShopError, JobActionAsRestrictionShopResponse, JobActionEnqueueData, JobActionEnqueueEnqueuerData, JobActionEnqueueEnqueuerError, JobActionEnqueueEnqueuerResponse, JobActionEnqueueError, JobActionEnqueueHotelData, JobActionEnqueueHotelError, JobActionEnqueueHotelResponse, JobActionEnqueueResponse, JobActionRetryData, JobActionRetryError, JobActionRetryResponse, JobActionTerminateData, JobActionTerminateError, JobActionTerminateResponse, LocationGetStatusData, LocationGetStatusError, LocationGetStatusResponse, OrganizationActionBulkSaveData, OrganizationActionBulkSaveError, OrganizationActionBulkSaveResponse, OrganizationActionProvisionData, OrganizationActionProvisionError, OrganizationActionProvisionResponse, OrganizationActionSaveData, OrganizationActionSaveError, OrganizationActionSaveResponse, OrganizationGetChangeLogData, OrganizationGetChangeLogError, OrganizationGetChangeLogResponse, OrganizationGetData, OrganizationGetError, OrganizationGetResponse, OrganizationInsertData, OrganizationInsertError, OrganizationInsertResponse, OrganizationLimitGetChangeLogData, OrganizationLimitGetChangeLogError, OrganizationLimitGetChangeLogResponse, OrganizationLimitGetSettingsData, OrganizationLimitGetSettingsError, OrganizationLimitGetSettingsResponse, OrganizationLimitQueryData, OrganizationLimitQueryError, OrganizationLimitQueryResponse, OrganizationLimitSaveData, OrganizationLimitSaveError, OrganizationLimitSaveResponse, OrganizationQueryData, OrganizationQueryError, OrganizationQueryResponse, OrganizationSaveData, OrganizationSaveError, OrganizationSaveResponse, RateScrapeMetadataActionAddProblemData, RateScrapeMetadataActionAddProblemError, RateScrapeMetadataActionAddProblemResponse, RateScrapeMetadataActionBulkSaveData, RateScrapeMetadataActionBulkSaveError, RateScrapeMetadataActionBulkSaveResponse, RateScrapeMetadataActionCachedShoppingMetricsData, RateScrapeMetadataActionCachedShoppingMetricsError, RateScrapeMetadataActionCachedShoppingMetricsResponse, RateScrapeMetadataActionClearData, RateScrapeMetadataActionClearError, RateScrapeMetadataActionClearResponse, RateScrapeMetadataActionPromoteData, RateScrapeMetadataActionPromoteError, RateScrapeMetadataActionPromoteResponse, RateScrapeMetadataActionPropagateSharedData, RateScrapeMetadataActionPropagateSharedError, RateScrapeMetadataActionPropagateSharedResponse, RateScrapeMetadataGetChangeLogData, RateScrapeMetadataGetChangeLogError, RateScrapeMetadataGetChangeLogResponse, RateScrapeMetadataGetData, RateScrapeMetadataGetError, RateScrapeMetadataGetResponse, RateScrapeMetadataQueryData, RateScrapeMetadataQueryError, RateScrapeMetadataQueryResponse, RateScrapeMetadataSaveData, RateScrapeMetadataSaveError, RateScrapeMetadataSaveResponse, SessionDeleteData, SessionDeleteError, SessionDeleteResponse, SessionNewSessionData, SessionNewSessionError, SessionNewSessionResponse, SessionQueryData, SessionQueryError, SessionQueryResponse, SharedRateScrapeMetadataActionPropagateData, SharedRateScrapeMetadataActionPropagateError, SharedRateScrapeMetadataActionPropagateResponse, SharedRateScrapeMetadataActionStatsData, SharedRateScrapeMetadataActionStatsError, SharedRateScrapeMetadataActionStatsResponse, SharedRateScrapeMetadataGetChangeLogData, SharedRateScrapeMetadataGetChangeLogError, SharedRateScrapeMetadataGetChangeLogResponse, SharedRateScrapeMetadataGetData, SharedRateScrapeMetadataGetError, SharedRateScrapeMetadataGetResponse, SharedRateScrapeMetadataSaveData, SharedRateScrapeMetadataSaveError, SharedRateScrapeMetadataSaveResponse, SystemValueActionGetCacheData, SystemValueActionGetCacheError, SystemValueActionGetCacheResponse, SystemValueActionQueryAllData, SystemValueActionQueryAllError, SystemValueActionQueryAllResponse, SystemValueActionReloadData, SystemValueActionReloadError, SystemValueActionReloadResponse, SystemValueSaveData, SystemValueSaveError, SystemValueSaveResponse, UserGetChangeLogData, UserGetChangeLogError, UserGetChangeLogResponse, UserGetData, UserGetError, UserGetResponse, UserQueryData, UserQueryError, UserQueryResponse } from '../types.gen.js';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const changeLogQueryQueryKey = (options: Options<ChangeLogQueryData>) => createQueryKey('changeLogQuery', options);

/**
 * Query multiple change log rows.
 */
export const changeLogQueryOptions = (options: Options<ChangeLogQueryData>) => queryOptions<ChangeLogQueryResponse, ChangeLogQueryError, ChangeLogQueryResponse, ReturnType<typeof changeLogQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await changeLogQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: changeLogQueryQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const changeLogQueryInfiniteQueryKey = (options: Options<ChangeLogQueryData>): QueryKey<Options<ChangeLogQueryData>> => createQueryKey('changeLogQuery', options, true);

/**
 * Query multiple change log rows.
 */
export const changeLogQueryInfiniteOptions = (options: Options<ChangeLogQueryData>) => {
    const opts = infiniteQueryOptions<ChangeLogQueryResponse, ChangeLogQueryError, InfiniteData<ChangeLogQueryResponse>, QueryKey<Options<ChangeLogQueryData>>, number | Pick<QueryKey<Options<ChangeLogQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ChangeLogQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await changeLogQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: changeLogQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const dataRequestListQueryKey = (options?: Options<DataRequestListData>) => createQueryKey('dataRequestList', options);

/**
 * Query the proposed requests
 */
export const dataRequestListOptions = (options?: Options<DataRequestListData>) => queryOptions<DataRequestListResponse, DataRequestListError, DataRequestListResponse, ReturnType<typeof dataRequestListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dataRequestList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dataRequestListQueryKey(options)
});

/**
 * Propose a data request
 */
export const dataRequestHostMutation = (options?: Partial<Options<DataRequestHostData>>): UseMutationOptions<DataRequestHostResponse, DataRequestHostError, Options<DataRequestHostData>> => {
    const mutationOptions: UseMutationOptions<DataRequestHostResponse, DataRequestHostError, Options<DataRequestHostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dataRequestHost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve the given request
 */
export const dataRequestActionApproveMutation = (options?: Partial<Options<DataRequestActionApproveData>>): UseMutationOptions<DataRequestActionApproveResponse, DataRequestActionApproveError, Options<DataRequestActionApproveData>> => {
    const mutationOptions: UseMutationOptions<DataRequestActionApproveResponse, DataRequestActionApproveError, Options<DataRequestActionApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dataRequestActionApprove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject the given request for the given reason
 */
export const dataRequestActionRejectMutation = (options?: Partial<Options<DataRequestActionRejectData>>): UseMutationOptions<DataRequestActionRejectResponse, DataRequestActionRejectError, Options<DataRequestActionRejectData>> => {
    const mutationOptions: UseMutationOptions<DataRequestActionRejectResponse, DataRequestActionRejectError, Options<DataRequestActionRejectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dataRequestActionReject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const hotelActionStatusesQueryKey = (options: Options<HotelActionStatusesData>) => createQueryKey('hotelActionStatuses', options);

/**
 * Return the status of multiple hotels, the results are sorted by id
 */
export const hotelActionStatusesOptions = (options: Options<HotelActionStatusesData>) => queryOptions<HotelActionStatusesResponse, HotelActionStatusesError, HotelActionStatusesResponse, ReturnType<typeof hotelActionStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelActionStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelActionStatusesQueryKey(options)
});

/**
 * Record a usage problem with a hotel field
 */
export const hotelActionAddProblemMutation = (options?: Partial<Options<HotelActionAddProblemData>>): UseMutationOptions<HotelActionAddProblemResponse, HotelActionAddProblemError, Options<HotelActionAddProblemData>> => {
    const mutationOptions: UseMutationOptions<HotelActionAddProblemResponse, HotelActionAddProblemError, Options<HotelActionAddProblemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelActionAddProblem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const hotelGetStatusQueryKey = (options: Options<HotelGetStatusData>) => createQueryKey('hotelGetStatus', options);

/**
 * Return the status of the hotel
 */
export const hotelGetStatusOptions = (options: Options<HotelGetStatusData>) => queryOptions<HotelGetStatusResponse, HotelGetStatusError, HotelGetStatusResponse, ReturnType<typeof hotelGetStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelGetStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelGetStatusQueryKey(options)
});

export const hotelSettingQueryQueryKey = (options?: Options<HotelSettingQueryData>) => createQueryKey('hotelSettingQuery', options);

/**
 * Query multiple settings
 */
export const hotelSettingQueryOptions = (options?: Options<HotelSettingQueryData>) => queryOptions<HotelSettingQueryResponse, HotelSettingQueryError, HotelSettingQueryResponse, ReturnType<typeof hotelSettingQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelSettingQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelSettingQueryQueryKey(options)
});

export const hotelSettingQueryInfiniteQueryKey = (options?: Options<HotelSettingQueryData>): QueryKey<Options<HotelSettingQueryData>> => createQueryKey('hotelSettingQuery', options, true);

/**
 * Query multiple settings
 */
export const hotelSettingQueryInfiniteOptions = (options?: Options<HotelSettingQueryData>) => {
    const opts = infiniteQueryOptions<HotelSettingQueryResponse, HotelSettingQueryError, InfiniteData<HotelSettingQueryResponse>, QueryKey<Options<HotelSettingQueryData>>, number | Pick<QueryKey<Options<HotelSettingQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<HotelSettingQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await hotelSettingQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: hotelSettingQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const hotelSettingQueryShoppingQueryKey = (options?: Options<HotelSettingQueryShoppingData>) => createQueryKey('hotelSettingQueryShopping', options);

/**
 * Query HotelSettings that have any shopping option enabled
 */
export const hotelSettingQueryShoppingOptions = (options?: Options<HotelSettingQueryShoppingData>) => queryOptions<HotelSettingQueryShoppingResponse, HotelSettingQueryShoppingError, HotelSettingQueryShoppingResponse, ReturnType<typeof hotelSettingQueryShoppingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelSettingQueryShopping({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelSettingQueryShoppingQueryKey(options)
});

export const hotelSettingQueryShoppingInfiniteQueryKey = (options?: Options<HotelSettingQueryShoppingData>): QueryKey<Options<HotelSettingQueryShoppingData>> => createQueryKey('hotelSettingQueryShopping', options, true);

/**
 * Query HotelSettings that have any shopping option enabled
 */
export const hotelSettingQueryShoppingInfiniteOptions = (options?: Options<HotelSettingQueryShoppingData>) => {
    const opts = infiniteQueryOptions<HotelSettingQueryShoppingResponse, HotelSettingQueryShoppingError, InfiniteData<HotelSettingQueryShoppingResponse>, QueryKey<Options<HotelSettingQueryShoppingData>>, number | Pick<QueryKey<Options<HotelSettingQueryShoppingData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<HotelSettingQueryShoppingData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await hotelSettingQueryShopping({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: hotelSettingQueryShoppingInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const hotelSettingGetSettingsQueryKey = (options: Options<HotelSettingGetSettingsData>) => createQueryKey('hotelSettingGetSettings', options);

/**
 * Get settings
 */
export const hotelSettingGetSettingsOptions = (options: Options<HotelSettingGetSettingsData>) => queryOptions<HotelSettingGetSettingsResponse, HotelSettingGetSettingsError, HotelSettingGetSettingsResponse, ReturnType<typeof hotelSettingGetSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelSettingGetSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelSettingGetSettingsQueryKey(options)
});

/**
 * Save settings
 */
export const hotelSettingSaveMutation = (options?: Partial<Options<HotelSettingSaveData>>): UseMutationOptions<HotelSettingSaveResponse, HotelSettingSaveError, Options<HotelSettingSaveData>> => {
    const mutationOptions: UseMutationOptions<HotelSettingSaveResponse, HotelSettingSaveError, Options<HotelSettingSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelSettingSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const hotelSettingGetChangeLogQueryKey = (options: Options<HotelSettingGetChangeLogData>) => createQueryKey('hotelSettingGetChangeLog', options);

/**
 * Load the settings change log for an id
 */
export const hotelSettingGetChangeLogOptions = (options: Options<HotelSettingGetChangeLogData>) => queryOptions<HotelSettingGetChangeLogResponse, HotelSettingGetChangeLogError, HotelSettingGetChangeLogResponse, ReturnType<typeof hotelSettingGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelSettingGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelSettingGetChangeLogQueryKey(options)
});

/**
 * Enqueue the learning message again, with the appendLearn indicator set
 */
export const jobActionAsAppendLearnMutation = (options?: Partial<Options<JobActionAsAppendLearnData>>): UseMutationOptions<JobActionAsAppendLearnResponse, JobActionAsAppendLearnError, Options<JobActionAsAppendLearnData>> => {
    const mutationOptions: UseMutationOptions<JobActionAsAppendLearnResponse, JobActionAsAppendLearnError, Options<JobActionAsAppendLearnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobActionAsAppendLearn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue the shopping message again, with a restriction level set
 */
export const jobActionAsRestrictionShopMutation = (options?: Partial<Options<JobActionAsRestrictionShopData>>): UseMutationOptions<JobActionAsRestrictionShopResponse, JobActionAsRestrictionShopError, Options<JobActionAsRestrictionShopData>> => {
    const mutationOptions: UseMutationOptions<JobActionAsRestrictionShopResponse, JobActionAsRestrictionShopError, Options<JobActionAsRestrictionShopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobActionAsRestrictionShop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Manually enqueue a simple message
 */
export const jobActionEnqueueMutation = (options?: Partial<Options<JobActionEnqueueData>>): UseMutationOptions<JobActionEnqueueResponse, JobActionEnqueueError, Options<JobActionEnqueueData>> => {
    const mutationOptions: UseMutationOptions<JobActionEnqueueResponse, JobActionEnqueueError, Options<JobActionEnqueueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobActionEnqueue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Manually enqueue an enqueuer job
 */
export const jobActionEnqueueEnqueuerMutation = (options?: Partial<Options<JobActionEnqueueEnqueuerData>>): UseMutationOptions<JobActionEnqueueEnqueuerResponse, JobActionEnqueueEnqueuerError, Options<JobActionEnqueueEnqueuerData>> => {
    const mutationOptions: UseMutationOptions<JobActionEnqueueEnqueuerResponse, JobActionEnqueueEnqueuerError, Options<JobActionEnqueueEnqueuerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobActionEnqueueEnqueuer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue a hotel/site/[day] message for lambda consumption
 */
export const jobActionEnqueueHotelMutation = (options?: Partial<Options<JobActionEnqueueHotelData>>): UseMutationOptions<JobActionEnqueueHotelResponse, JobActionEnqueueHotelError, Options<JobActionEnqueueHotelData>> => {
    const mutationOptions: UseMutationOptions<JobActionEnqueueHotelResponse, JobActionEnqueueHotelError, Options<JobActionEnqueueHotelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobActionEnqueueHotel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue the message again after incrementing the retry parameter
 */
export const jobActionRetryMutation = (options?: Partial<Options<JobActionRetryData>>): UseMutationOptions<JobActionRetryResponse, JobActionRetryError, Options<JobActionRetryData>> => {
    const mutationOptions: UseMutationOptions<JobActionRetryResponse, JobActionRetryError, Options<JobActionRetryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobActionRetry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Terminate the given rate shop message
 */
export const jobActionTerminateMutation = (options?: Partial<Options<JobActionTerminateData>>): UseMutationOptions<JobActionTerminateResponse, JobActionTerminateError, Options<JobActionTerminateData>> => {
    const mutationOptions: UseMutationOptions<JobActionTerminateResponse, JobActionTerminateError, Options<JobActionTerminateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobActionTerminate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const locationGetStatusQueryKey = (options: Options<LocationGetStatusData>) => createQueryKey('locationGetStatus', options);

/**
 * Return the status of the city
 */
export const locationGetStatusOptions = (options: Options<LocationGetStatusData>) => queryOptions<LocationGetStatusResponse, LocationGetStatusError, LocationGetStatusResponse, ReturnType<typeof locationGetStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await locationGetStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: locationGetStatusQueryKey(options)
});

export const organizationLimitQueryQueryKey = (options?: Options<OrganizationLimitQueryData>) => createQueryKey('organizationLimitQuery', options);

/**
 * Query multiple settings
 */
export const organizationLimitQueryOptions = (options?: Options<OrganizationLimitQueryData>) => queryOptions<OrganizationLimitQueryResponse, OrganizationLimitQueryError, OrganizationLimitQueryResponse, ReturnType<typeof organizationLimitQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationLimitQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationLimitQueryQueryKey(options)
});

export const organizationLimitQueryInfiniteQueryKey = (options?: Options<OrganizationLimitQueryData>): QueryKey<Options<OrganizationLimitQueryData>> => createQueryKey('organizationLimitQuery', options, true);

/**
 * Query multiple settings
 */
export const organizationLimitQueryInfiniteOptions = (options?: Options<OrganizationLimitQueryData>) => {
    const opts = infiniteQueryOptions<OrganizationLimitQueryResponse, OrganizationLimitQueryError, InfiniteData<OrganizationLimitQueryResponse>, QueryKey<Options<OrganizationLimitQueryData>>, number | Pick<QueryKey<Options<OrganizationLimitQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<OrganizationLimitQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await organizationLimitQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: organizationLimitQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const organizationLimitGetSettingsQueryKey = (options: Options<OrganizationLimitGetSettingsData>) => createQueryKey('organizationLimitGetSettings', options);

/**
 * Get settings
 */
export const organizationLimitGetSettingsOptions = (options: Options<OrganizationLimitGetSettingsData>) => queryOptions<OrganizationLimitGetSettingsResponse, OrganizationLimitGetSettingsError, OrganizationLimitGetSettingsResponse, ReturnType<typeof organizationLimitGetSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationLimitGetSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationLimitGetSettingsQueryKey(options)
});

/**
 * Save settings
 */
export const organizationLimitSaveMutation = (options?: Partial<Options<OrganizationLimitSaveData>>): UseMutationOptions<OrganizationLimitSaveResponse, OrganizationLimitSaveError, Options<OrganizationLimitSaveData>> => {
    const mutationOptions: UseMutationOptions<OrganizationLimitSaveResponse, OrganizationLimitSaveError, Options<OrganizationLimitSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationLimitSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationLimitGetChangeLogQueryKey = (options: Options<OrganizationLimitGetChangeLogData>) => createQueryKey('organizationLimitGetChangeLog', options);

/**
 * Load the settings change log for an id
 */
export const organizationLimitGetChangeLogOptions = (options: Options<OrganizationLimitGetChangeLogData>) => queryOptions<OrganizationLimitGetChangeLogResponse, OrganizationLimitGetChangeLogError, OrganizationLimitGetChangeLogResponse, ReturnType<typeof organizationLimitGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationLimitGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationLimitGetChangeLogQueryKey(options)
});

export const organizationQueryQueryKey = (options?: Options<OrganizationQueryData>) => createQueryKey('organizationQuery', options);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const organizationQueryOptions = (options?: Options<OrganizationQueryData>) => queryOptions<OrganizationQueryResponse, OrganizationQueryError, OrganizationQueryResponse, ReturnType<typeof organizationQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationQueryQueryKey(options)
});

export const organizationQueryInfiniteQueryKey = (options?: Options<OrganizationQueryData>): QueryKey<Options<OrganizationQueryData>> => createQueryKey('organizationQuery', options, true);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const organizationQueryInfiniteOptions = (options?: Options<OrganizationQueryData>) => {
    const opts = infiniteQueryOptions<OrganizationQueryResponse, OrganizationQueryError, InfiniteData<OrganizationQueryResponse>, QueryKey<Options<OrganizationQueryData>>, number | Pick<QueryKey<Options<OrganizationQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<OrganizationQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await organizationQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: organizationQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Insert a single noun row.
 */
export const organizationInsertMutation = (options?: Partial<Options<OrganizationInsertData>>): UseMutationOptions<OrganizationInsertResponse, OrganizationInsertError, Options<OrganizationInsertData>> => {
    const mutationOptions: UseMutationOptions<OrganizationInsertResponse, OrganizationInsertError, Options<OrganizationInsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationInsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const organizationActionBulkSaveMutation = (options?: Partial<Options<OrganizationActionBulkSaveData>>): UseMutationOptions<OrganizationActionBulkSaveResponse, OrganizationActionBulkSaveError, Options<OrganizationActionBulkSaveData>> => {
    const mutationOptions: UseMutationOptions<OrganizationActionBulkSaveResponse, OrganizationActionBulkSaveError, Options<OrganizationActionBulkSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationActionBulkSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create an organization and an assigned user
 */
export const organizationActionProvisionMutation = (options?: Partial<Options<OrganizationActionProvisionData>>): UseMutationOptions<OrganizationActionProvisionResponse, OrganizationActionProvisionError, Options<OrganizationActionProvisionData>> => {
    const mutationOptions: UseMutationOptions<OrganizationActionProvisionResponse, OrganizationActionProvisionError, Options<OrganizationActionProvisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationActionProvision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const organizationActionSaveMutation = (options?: Partial<Options<OrganizationActionSaveData>>): UseMutationOptions<OrganizationActionSaveResponse, OrganizationActionSaveError, Options<OrganizationActionSaveData>> => {
    const mutationOptions: UseMutationOptions<OrganizationActionSaveResponse, OrganizationActionSaveError, Options<OrganizationActionSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationActionSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationGetQueryKey = (options: Options<OrganizationGetData>) => createQueryKey('organizationGet', options);

/**
 * Load a single noun by internal id
 */
export const organizationGetOptions = (options: Options<OrganizationGetData>) => queryOptions<OrganizationGetResponse, OrganizationGetError, OrganizationGetResponse, ReturnType<typeof organizationGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationGetQueryKey(options)
});

/**
 * Update a single noun row.
 */
export const organizationSaveMutation = (options?: Partial<Options<OrganizationSaveData>>): UseMutationOptions<OrganizationSaveResponse, OrganizationSaveError, Options<OrganizationSaveData>> => {
    const mutationOptions: UseMutationOptions<OrganizationSaveResponse, OrganizationSaveError, Options<OrganizationSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationGetChangeLogQueryKey = (options: Options<OrganizationGetChangeLogData>) => createQueryKey('organizationGetChangeLog', options);

/**
 * Load the change log for a single noun by internal id
 */
export const organizationGetChangeLogOptions = (options: Options<OrganizationGetChangeLogData>) => queryOptions<OrganizationGetChangeLogResponse, OrganizationGetChangeLogError, OrganizationGetChangeLogResponse, ReturnType<typeof organizationGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationGetChangeLogQueryKey(options)
});

export const rateScrapeMetadataQueryQueryKey = (options?: Options<RateScrapeMetadataQueryData>) => createQueryKey('rateScrapeMetadataQuery', options);

/**
 * Query many metadatas
 */
export const rateScrapeMetadataQueryOptions = (options?: Options<RateScrapeMetadataQueryData>) => queryOptions<RateScrapeMetadataQueryResponse, RateScrapeMetadataQueryError, RateScrapeMetadataQueryResponse, ReturnType<typeof rateScrapeMetadataQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rateScrapeMetadataQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rateScrapeMetadataQueryQueryKey(options)
});

export const rateScrapeMetadataQueryInfiniteQueryKey = (options?: Options<RateScrapeMetadataQueryData>): QueryKey<Options<RateScrapeMetadataQueryData>> => createQueryKey('rateScrapeMetadataQuery', options, true);

/**
 * Query many metadatas
 */
export const rateScrapeMetadataQueryInfiniteOptions = (options?: Options<RateScrapeMetadataQueryData>) => {
    const opts = infiniteQueryOptions<RateScrapeMetadataQueryResponse, RateScrapeMetadataQueryError, InfiniteData<RateScrapeMetadataQueryResponse>, QueryKey<Options<RateScrapeMetadataQueryData>>, number | Pick<QueryKey<Options<RateScrapeMetadataQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RateScrapeMetadataQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await rateScrapeMetadataQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rateScrapeMetadataQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Save many metadata.
 */
export const rateScrapeMetadataActionBulkSaveMutation = (options?: Partial<Options<RateScrapeMetadataActionBulkSaveData>>): UseMutationOptions<RateScrapeMetadataActionBulkSaveResponse, RateScrapeMetadataActionBulkSaveError, Options<RateScrapeMetadataActionBulkSaveData>> => {
    const mutationOptions: UseMutationOptions<RateScrapeMetadataActionBulkSaveResponse, RateScrapeMetadataActionBulkSaveError, Options<RateScrapeMetadataActionBulkSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rateScrapeMetadataActionBulkSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rateScrapeMetadataActionCachedShoppingMetricsQueryKey = (options: Options<RateScrapeMetadataActionCachedShoppingMetricsData>) => createQueryKey('rateScrapeMetadataActionCachedShoppingMetrics', options);

/**
 * Cached summary shopping metrics for hotel/sites
 */
export const rateScrapeMetadataActionCachedShoppingMetricsOptions = (options: Options<RateScrapeMetadataActionCachedShoppingMetricsData>) => queryOptions<RateScrapeMetadataActionCachedShoppingMetricsResponse, RateScrapeMetadataActionCachedShoppingMetricsError, RateScrapeMetadataActionCachedShoppingMetricsResponse, ReturnType<typeof rateScrapeMetadataActionCachedShoppingMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rateScrapeMetadataActionCachedShoppingMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rateScrapeMetadataActionCachedShoppingMetricsQueryKey(options)
});

export const rateScrapeMetadataGetQueryKey = (options: Options<RateScrapeMetadataGetData>) => createQueryKey('rateScrapeMetadataGet', options);

/**
 * Query one metadata
 */
export const rateScrapeMetadataGetOptions = (options: Options<RateScrapeMetadataGetData>) => queryOptions<RateScrapeMetadataGetResponse, RateScrapeMetadataGetError, RateScrapeMetadataGetResponse, ReturnType<typeof rateScrapeMetadataGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rateScrapeMetadataGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rateScrapeMetadataGetQueryKey(options)
});

/**
 * Save one metadata with options.
 */
export const rateScrapeMetadataSaveMutation = (options?: Partial<Options<RateScrapeMetadataSaveData>>): UseMutationOptions<RateScrapeMetadataSaveResponse, RateScrapeMetadataSaveError, Options<RateScrapeMetadataSaveData>> => {
    const mutationOptions: UseMutationOptions<RateScrapeMetadataSaveResponse, RateScrapeMetadataSaveError, Options<RateScrapeMetadataSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rateScrapeMetadataSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record a usage problem with a rate scrape metadata field
 */
export const rateScrapeMetadataActionAddProblemMutation = (options?: Partial<Options<RateScrapeMetadataActionAddProblemData>>): UseMutationOptions<RateScrapeMetadataActionAddProblemResponse, RateScrapeMetadataActionAddProblemError, Options<RateScrapeMetadataActionAddProblemData>> => {
    const mutationOptions: UseMutationOptions<RateScrapeMetadataActionAddProblemResponse, RateScrapeMetadataActionAddProblemError, Options<RateScrapeMetadataActionAddProblemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rateScrapeMetadataActionAddProblem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear all rate scrape metadata and start over, leaving data issues
 */
export const rateScrapeMetadataActionClearMutation = (options?: Partial<Options<RateScrapeMetadataActionClearData>>): UseMutationOptions<RateScrapeMetadataActionClearResponse, RateScrapeMetadataActionClearError, Options<RateScrapeMetadataActionClearData>> => {
    const mutationOptions: UseMutationOptions<RateScrapeMetadataActionClearResponse, RateScrapeMetadataActionClearError, Options<RateScrapeMetadataActionClearData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rateScrapeMetadataActionClear({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Copy hotel metadata to shared metadata
 */
export const rateScrapeMetadataActionPromoteMutation = (options?: Partial<Options<RateScrapeMetadataActionPromoteData>>): UseMutationOptions<RateScrapeMetadataActionPromoteResponse, RateScrapeMetadataActionPromoteError, Options<RateScrapeMetadataActionPromoteData>> => {
    const mutationOptions: UseMutationOptions<RateScrapeMetadataActionPromoteResponse, RateScrapeMetadataActionPromoteError, Options<RateScrapeMetadataActionPromoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rateScrapeMetadataActionPromote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create metadata for a hotel from its booking engine shared metadata
 */
export const rateScrapeMetadataActionPropagateSharedMutation = (options?: Partial<Options<RateScrapeMetadataActionPropagateSharedData>>): UseMutationOptions<RateScrapeMetadataActionPropagateSharedResponse, RateScrapeMetadataActionPropagateSharedError, Options<RateScrapeMetadataActionPropagateSharedData>> => {
    const mutationOptions: UseMutationOptions<RateScrapeMetadataActionPropagateSharedResponse, RateScrapeMetadataActionPropagateSharedError, Options<RateScrapeMetadataActionPropagateSharedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rateScrapeMetadataActionPropagateShared({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rateScrapeMetadataGetChangeLogQueryKey = (options: Options<RateScrapeMetadataGetChangeLogData>) => createQueryKey('rateScrapeMetadataGetChangeLog', options);

/**
 * Load the change log for a single metadata
 */
export const rateScrapeMetadataGetChangeLogOptions = (options: Options<RateScrapeMetadataGetChangeLogData>) => queryOptions<RateScrapeMetadataGetChangeLogResponse, RateScrapeMetadataGetChangeLogError, RateScrapeMetadataGetChangeLogResponse, ReturnType<typeof rateScrapeMetadataGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rateScrapeMetadataGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rateScrapeMetadataGetChangeLogQueryKey(options)
});

export const sessionQueryQueryKey = (options?: Options<SessionQueryData>) => createQueryKey('sessionQuery', options);

/**
 * Query sessions.
 */
export const sessionQueryOptions = (options?: Options<SessionQueryData>) => queryOptions<SessionQueryResponse, SessionQueryError, SessionQueryResponse, ReturnType<typeof sessionQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sessionQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sessionQueryQueryKey(options)
});

export const sessionQueryInfiniteQueryKey = (options?: Options<SessionQueryData>): QueryKey<Options<SessionQueryData>> => createQueryKey('sessionQuery', options, true);

/**
 * Query sessions.
 */
export const sessionQueryInfiniteOptions = (options?: Options<SessionQueryData>) => {
    const opts = infiniteQueryOptions<SessionQueryResponse, SessionQueryError, InfiniteData<SessionQueryResponse>, QueryKey<Options<SessionQueryData>>, number | Pick<QueryKey<Options<SessionQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SessionQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await sessionQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sessionQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create a new session for the given user and for the given number of days. Delete any existing session for that user.
 */
export const sessionNewSessionMutation = (options?: Partial<Options<SessionNewSessionData>>): UseMutationOptions<SessionNewSessionResponse, SessionNewSessionError, Options<SessionNewSessionData>> => {
    const mutationOptions: UseMutationOptions<SessionNewSessionResponse, SessionNewSessionError, Options<SessionNewSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionNewSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete the given session by id.
 */
export const sessionDeleteMutation = (options?: Partial<Options<SessionDeleteData>>): UseMutationOptions<SessionDeleteResponse, SessionDeleteError, Options<SessionDeleteData>> => {
    const mutationOptions: UseMutationOptions<SessionDeleteResponse, SessionDeleteError, Options<SessionDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sharedRateScrapeMetadataGetQueryKey = (options: Options<SharedRateScrapeMetadataGetData>) => createQueryKey('sharedRateScrapeMetadataGet', options);

/**
 * Get one shared metadata
 */
export const sharedRateScrapeMetadataGetOptions = (options: Options<SharedRateScrapeMetadataGetData>) => queryOptions<SharedRateScrapeMetadataGetResponse, SharedRateScrapeMetadataGetError, SharedRateScrapeMetadataGetResponse, ReturnType<typeof sharedRateScrapeMetadataGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sharedRateScrapeMetadataGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sharedRateScrapeMetadataGetQueryKey(options)
});

/**
 * Save one metadata
 */
export const sharedRateScrapeMetadataSaveMutation = (options?: Partial<Options<SharedRateScrapeMetadataSaveData>>): UseMutationOptions<SharedRateScrapeMetadataSaveResponse, SharedRateScrapeMetadataSaveError, Options<SharedRateScrapeMetadataSaveData>> => {
    const mutationOptions: UseMutationOptions<SharedRateScrapeMetadataSaveResponse, SharedRateScrapeMetadataSaveError, Options<SharedRateScrapeMetadataSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sharedRateScrapeMetadataSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Propagate shared metadata to hotels that use that booking engine in shopping cities
 */
export const sharedRateScrapeMetadataActionPropagateMutation = (options?: Partial<Options<SharedRateScrapeMetadataActionPropagateData>>): UseMutationOptions<SharedRateScrapeMetadataActionPropagateResponse, SharedRateScrapeMetadataActionPropagateError, Options<SharedRateScrapeMetadataActionPropagateData>> => {
    const mutationOptions: UseMutationOptions<SharedRateScrapeMetadataActionPropagateResponse, SharedRateScrapeMetadataActionPropagateError, Options<SharedRateScrapeMetadataActionPropagateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sharedRateScrapeMetadataActionPropagate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sharedRateScrapeMetadataActionStatsQueryKey = (options: Options<SharedRateScrapeMetadataActionStatsData>) => createQueryKey('sharedRateScrapeMetadataActionStats', options);

/**
 * Return information about metadata set stats for the given booking engine
 */
export const sharedRateScrapeMetadataActionStatsOptions = (options: Options<SharedRateScrapeMetadataActionStatsData>) => queryOptions<SharedRateScrapeMetadataActionStatsResponse, SharedRateScrapeMetadataActionStatsError, SharedRateScrapeMetadataActionStatsResponse, ReturnType<typeof sharedRateScrapeMetadataActionStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sharedRateScrapeMetadataActionStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sharedRateScrapeMetadataActionStatsQueryKey(options)
});

export const sharedRateScrapeMetadataGetChangeLogQueryKey = (options: Options<SharedRateScrapeMetadataGetChangeLogData>) => createQueryKey('sharedRateScrapeMetadataGetChangeLog', options);

/**
 * Load the change log for a single shared metadata
 */
export const sharedRateScrapeMetadataGetChangeLogOptions = (options: Options<SharedRateScrapeMetadataGetChangeLogData>) => queryOptions<SharedRateScrapeMetadataGetChangeLogResponse, SharedRateScrapeMetadataGetChangeLogError, SharedRateScrapeMetadataGetChangeLogResponse, ReturnType<typeof sharedRateScrapeMetadataGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sharedRateScrapeMetadataGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sharedRateScrapeMetadataGetChangeLogQueryKey(options)
});

export const systemValueActionGetCacheQueryKey = (options?: Options<SystemValueActionGetCacheData>) => createQueryKey('systemValueActionGetCache', options);

/**
 * Retrieve all system values from cache
 */
export const systemValueActionGetCacheOptions = (options?: Options<SystemValueActionGetCacheData>) => queryOptions<SystemValueActionGetCacheResponse, SystemValueActionGetCacheError, SystemValueActionGetCacheResponse, ReturnType<typeof systemValueActionGetCacheQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemValueActionGetCache({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemValueActionGetCacheQueryKey(options)
});

export const systemValueActionQueryAllQueryKey = (options?: Options<SystemValueActionQueryAllData>) => createQueryKey('systemValueActionQueryAll', options);

/**
 * Retrieve all system values from the database
 */
export const systemValueActionQueryAllOptions = (options?: Options<SystemValueActionQueryAllData>) => queryOptions<SystemValueActionQueryAllResponse, SystemValueActionQueryAllError, SystemValueActionQueryAllResponse, ReturnType<typeof systemValueActionQueryAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemValueActionQueryAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemValueActionQueryAllQueryKey(options)
});

/**
 * Reload cache
 */
export const systemValueActionReloadMutation = (options?: Partial<Options<SystemValueActionReloadData>>): UseMutationOptions<SystemValueActionReloadResponse, SystemValueActionReloadError, Options<SystemValueActionReloadData>> => {
    const mutationOptions: UseMutationOptions<SystemValueActionReloadResponse, SystemValueActionReloadError, Options<SystemValueActionReloadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemValueActionReload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save a single value.
 */
export const systemValueSaveMutation = (options?: Partial<Options<SystemValueSaveData>>): UseMutationOptions<SystemValueSaveResponse, SystemValueSaveError, Options<SystemValueSaveData>> => {
    const mutationOptions: UseMutationOptions<SystemValueSaveResponse, SystemValueSaveError, Options<SystemValueSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemValueSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userQueryQueryKey = (options?: Options<UserQueryData>) => createQueryKey('userQuery', options);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const userQueryOptions = (options?: Options<UserQueryData>) => queryOptions<UserQueryResponse, UserQueryError, UserQueryResponse, ReturnType<typeof userQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userQueryQueryKey(options)
});

export const userQueryInfiniteQueryKey = (options?: Options<UserQueryData>): QueryKey<Options<UserQueryData>> => createQueryKey('userQuery', options, true);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const userQueryInfiniteOptions = (options?: Options<UserQueryData>) => {
    const opts = infiniteQueryOptions<UserQueryResponse, UserQueryError, InfiniteData<UserQueryResponse>, QueryKey<Options<UserQueryData>>, number | Pick<QueryKey<Options<UserQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UserQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await userQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const userGetQueryKey = (options: Options<UserGetData>) => createQueryKey('userGet', options);

/**
 * Load a single noun by internal id
 */
export const userGetOptions = (options: Options<UserGetData>) => queryOptions<UserGetResponse, UserGetError, UserGetResponse, ReturnType<typeof userGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetQueryKey(options)
});

export const userGetChangeLogQueryKey = (options: Options<UserGetChangeLogData>) => createQueryKey('userGetChangeLog', options);

/**
 * Load the change log for a single noun by internal id
 */
export const userGetChangeLogOptions = (options: Options<UserGetChangeLogData>) => queryOptions<UserGetChangeLogResponse, UserGetChangeLogError, UserGetChangeLogResponse, ReturnType<typeof userGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetChangeLogQueryKey(options)
});
